import {
  GetOneResult,
  RaRecord,
  UpdateParams,
  UpdateResult,
} from 'react-admin';
import { getJson, putJson } from '../../../utils/api';
import IHandler from './IHandler';

export default class StateHandler implements IHandler {
  static route = '/admin/state';

  static async getOneHandler<RecordType extends RaRecord = any>(): Promise<
    GetOneResult<RecordType>
  > {
    return getJson(this.route).then(async (response) => {
      const { data } = await response.json();

      return {
        data: {
          ...data,
          id: data.stateId,
        },
      };
    });
  }

  static async updateHandler<RecordType extends RaRecord = any>(
    _: string,
    params?: UpdateParams<any>,
  ): Promise<UpdateResult<RecordType>> {
    const payload = params?.data || {};

    return putJson(this.route, payload).then(async (response) => {
      const { data } = await response.json();

      return {
        data: {
          ...data,
          id: data.stateId,
        },
      };
    });
  }
}
